/**
 * @description: 自助大厅推荐设置
 * @author: hwx
 */
<template>
	<div class="srs-manage-wrap">
		<div class="srs-list" v-show="showList">
			<div class="row row-margin" v-if="list_menu_add">
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="addSrs">设置</button>
			</div>
			<div class="row">
				<label class="col-md-1 list-label-2">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="srs_shop"></select>
				</div>
				<label class="col-md-1 list-label-2">标题:</label>
				<div class="col-md-2">
					<input class="form-control" placeholder="请输入标题" v-model.trim="srs_tit">
				</div>
				<div class="pull-right">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="srsQuery">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="srs_list"></table>
			</div>
		</div>
		<!-- 新增、修改 -->
		<div class="srs-edit" v-show="!showList">
			<div class="page-tit">{{edit_tit}}</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>门店:</span>
					<i>*</i>
				</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_shop"></select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>推荐序号:</span>
					<i>*</i>
				</label>
				<div class="col-md-6">
					<input type="text" class="form-control" v-model.trim="edit_listorder" placeholder="请输入推荐序号">
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>标题:</span>
					<i>*</i>
				</label>
				<div class="col-md-6">
					<input type="text" class="form-control" v-model.trim="edit_name" placeholder="请输入标题">
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>商品类型:</span>
					<i>*</i>
				</label>
				<div class="col-md-6 ct-col">
					<select class="form-control" ref="edit_goods_type"></select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">
					<span>推荐商品/套餐:</span>
					<i>*</i>
				</label>
				<div class="col-md-6">
					<input class="form-control input-readonly" placeholder="请选择推荐商品或者商品套餐" v-model="edit_goods_txt" ref="edit_goods_txt" @click="openEditGoods" readonly>
				</div>
			</div>
			<div class="row edit-img">
				<label class="ctr-label-left">
					<span>推荐主图:</span>
					<i>*</i>
				</label>
				<div class="col-md-6 srs-dash">
					<div class="clearfix">
						<p>请上传推荐主图片（图片大小2M以内，尺寸为850*1650，jpg/png格式，样式16：9），仅1张</p>
						<img class="edit-img-cover" :src="edit_cover" @click="coverFun">
						<input type="file" id="coverFile" ref="cover_file" @change="uploadCover($event)">
					</div>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="editSrs">确定</button>
			</div>
		</div>
		<!-- 商品列表 -->
		<div class="edit-goods-alert" ref="edit_goods_alert">
			<div class="row">
				<div class="col-md-4 ct-col">
					<select class="form-control" data-placeholder="请选择商品类型" ref="goods_type">
						<option value=""></option>
					</select>
				</div>
				<div class="col-md-6">
					<input type="text" class="form-control" placeholder="请输入商品名称" v-model="goods_name" @keyup.13="queryGoods" />
				</div>
				<div class="col-md-2">
					<button type="button" class="btn btn-flat btn-small btn-orange" @click="queryGoods">查询</button>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="goods_list"></table>
			</div>
			<div class="row btns">
				<button type="button" class="btn btn-flat btn-small btn-orange" @click="saveGoods">保存</button>
				<button type="button" class="btn btn-flat btn-small btn-gray" @click="closeGoods">取消</button>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: '',
		data() {
			return {
				showList: true,
				modify: '1',
				srs_tit: '',
				list_menu_add: false,
            	list_menu_op: [],

				edit_id: '',
				edit_tit: '',
				edit_listorder: '',
				edit_name: '',
				edit_goods_txt: '',
				goods_id: '',
				goods_type_id: '',
				goods_name: '',
				edit_cover: require('../../assets/images/uld_btn.png'),

				srs_good_type: [],
				srs_sign: '',
				srs_sign_id: '',
			}
		},
		mounted: function() {
			this.getMenuOp();
			this.getShopData();

			this.getCusPakage();
		},
		methods: {
			// 获取权限
			getMenuOp() {
				let _this = this,
					menu = [];
				if(!$.isEmptyObject(this.$store.state.menunew)) {
					menu = JSON.parse(this.$store.state.menunew);
					$.each(menu, function(k, v) {
						if(v.id == '542') {
							menu = v.submenu;
							$.each(menu, function(m, n) {
								if(n.id == '836') {
									menu = n.submenu;
								}
							});
						}
					});

					_this.list_menu_op = [];
					$.each(menu, function(x, y) {
						if(y.id == '939') {
							_this.list_menu_add = true;
						}
						if(y.id == '940') {
							_this.list_menu_op.push({cls: 'text-blue edit', name: '修改'});
						}
						if(y.id == '941') {
							_this.list_menu_op.push({cls: 'text-blue del', name: '删除'});
						}
					});
				}
			},
			// 门店
			getShopData: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.srs_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});
							$(_this.$refs.srs_shop).val(data.response.result[1].id).trigger('change');
							_this.initTable();

							arr.shift();
							$(_this.$refs.edit_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								_this.edit_goods_txt = '';
								_this.goods_id = '';
								_this.goods_type_id = '';
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			// 初始化列表
			initTable: function() {
				let _this = this;
				$(_this.$refs.srs_list).bootstrapTable('destroy');
				$(_this.$refs.srs_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getSrsList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "shop_name",
						title: "门店",
						width: "10%",
						valign: 'middle'
					}, {
						field: "listorder",
						title: "推荐序号",
						width: "10%",
						valign: 'middle'
					}, {
						field: "title",
						title: "标题",
						width: "10%",
						valign: 'middle'
					}, {
						field: "goods_type_name",
						title: "商品类型",
						width: "10%",
						valign: 'middle'
					}, {
						field: "goods_name",
						title: "推荐商品/套餐",
						width: "10%",
						valign: 'middle'
					}, {
						title: "操作",
						width: "15%",
						valign: 'middle',
						events: {
							'click .edit': function(e, value, row, index) {
								_this.modify = '2';
								_this.edit_id = row.id;
								_this.edit_tit = '修改设置';
								$(_this.$refs.edit_shop).val(row.shop_id).trigger('change');
								_this.edit_listorder = row.listorder;
								_this.edit_name = row.title;
								$(_this.$refs.edit_goods_type).val(row.outside_goods_type).trigger('change');
								_this.edit_goods_txt = row.goods_name;
								_this.goods_id = row.merchant_goods_id;
								_this.goods_type_id = row.goods_type;
								if(row.picture != '') {
									_this.edit_cover = row.picture;
									$('.edit-img-cover').attr('suc', '1');
								} else {
									_this.edit_cover = require('../../assets/images/uld_btn.png');
									$('.edit-img-cover').removeAttr('suc');
								}
								_this.showList = false;
							},
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delSrs(row.id);
								});
							}
						},
						formatter: function(value, row, index) {
							let op_html = '';
							$.each(_this.list_menu_op, function(k, v) {
								op_html += '<span class="'+ v.cls +'">'+ v.name +'</span>&nbsp;&nbsp;';
							});
							return op_html;
						}
					}]
				});
			},
			getSrsList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $.trim($(_this.$refs.srs_shop).val()),
							"title": _this.srs_tit
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Hall/getBannersList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.total,
								rows: data.response.result.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			srsQuery: function() {
				this.initTable();
			},
			// 删除
			delSrs(id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Hall/delBanner",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg('删除成功');
							$(_this.$refs.srs_list).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 点击设置
			addSrs() {
				let _this = this;
				_this.modify = '1';
				_this.edit_tit = '新增设置';
				$(_this.$refs.edit_shop).val('').trigger('change');
				_this.edit_listorder = '';
				_this.edit_name = '';
				$(_this.$refs.edit_goods_type).val('').trigger('change');
				_this.edit_goods_txt = '';
				_this.goods_id = '';
				_this.goods_type_id = '';
				_this.edit_cover = require('../../assets/images/uld_btn.png');
				$('.edit-img-cover').removeAttr('suc');
				_this.showList = false;
			},
			// 打开选择商品
			openEditGoods: function() {
				let _this = this;

				$(_this.$refs.goods_type).val('').trigger('change');
				_this.srs_sign = '';
				_this.initGoodsTable();
				layer.open({
					type: 1,
					title: '选择商品',
					skin: 'layui-layer-rim', // 加上边框
					area: ['700px', ''], // 宽高
					content: $(_this.$refs.edit_goods_alert)
				});
			},
			// 商品类型
			getCusPakage() {
				const _this = this;

				_this.srs_good_type = [{
					id: "0",
					text: "全部"
				}, {
					id: "-2",
					text: "商品套餐",
					sign: '-2',
					sign_id: '0'
				}];
				Vue.axios.post('PublicData/api_getWaresType', {
					"header": Vue.request_header,
					"request": {
						"param": {}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						res.data.response.result.data.forEach(v => {
							_this.srs_good_type.push({
								id: '-2' + v.id,
								text: v.name,
								sign: '-2',
								sign_id: v.id
							});
						});
						_this.getGoodsType();
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg('出错啦');
				});
			},
			getGoodsType: function() {
				let _this = this;
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getGoodsType",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							let arr = [];
							$.each(data.response.result.data, function(k, v) {
								arr.push({ id: v.id, text: v.name });
								_this.srs_good_type.push({
									id: v.id,
									text: v.name
								});
							});
							$(_this.$refs.edit_goods_type).select2({
								data: arr,
								width: '100%'
							});

							$(_this.$refs.goods_type).select2({
								data: _this.srs_good_type,
								width: '100%'
							}).on("select2:select", function(e) {
								_this.srs_sign = e.params.data.sign;
								if(_this.srs_sign == '-2') {
									_this.srs_sign_id = e.params.data.sign_id;
									_this.initGoodsPackage();
								} else {
									_this.initGoodsTable();
								}
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 商品列表
			initGoodsTable: function() {
				let _this = this;
				$(_this.$refs.goods_list).bootstrapTable('destroy');
				$(_this.$refs.goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getGoodsList(params);
					},
					sidePagination: "server",
					columns: [{
						radio: true,
						title: '单选'
					}, {
						field: "goods_type_name",
						title: "类型"
					}, {
						field: "goods_name",
						title: "名称"
					}, {
						field: "goods_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			getGoodsList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseFloat(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.edit_shop).val(),
							"goods_type": $.trim($(_this.$refs.goods_type).val()),
							"goods_name": _this.goods_name,
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 商品套餐列表
			initGoodsPackage: function() {
				let _this = this;
				$(_this.$refs.goods_list).bootstrapTable('destroy');
				$(_this.$refs.goods_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 5,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getGoodsPackage(params);
					},
					sidePagination: "server",
					columns: [{
						radio: true,
						title: '单选'
					}, {
						field: "goods_type_name",
						title: "类型",
						formatter: function(value, row, index) {
							return '商品套餐'
						}
					}, {
						field: "name",
						title: "名称"
					}, {
						field: "package_unit_name",
						title: "单位"
					}],
					clickToSelect: true
				});
			},
			getGoodsPackage: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.edit_shop).val(),
							"goods_type": _this.srs_sign_id,
							"goods_name": _this.goods_name,
							"status": '1'
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);

				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "merchantGoods/searchMerchantGoodsPackage",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							params.success({
								total: data.response.result.data.total,
								rows: data.response.result.data.rows
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 关闭选择商品
			closeGoods: function() {
				layer.close(layer.index);
			},
			// 查询商品
			queryGoods: function() {
				if(_this.srs_sign == '-2') {
					this.initGoodsPackage();
				} else {
					this.initGoodsTable();
				}
			},
			// 保存商品
			saveGoods: function() {
				let _this = this;
				$.map($(_this.$refs.goods_list).bootstrapTable('getSelections'), function(row) {
					if(_this.srs_sign == '-2') {
						_this.goods_id = row.id;
						_this.goods_type_id = '0';
						_this.edit_goods_txt = row.name;
					} else {
						_this.goods_id = row.id;
						_this.goods_type_id = row.goods_type;
						_this.edit_goods_txt = row.goods_name;
					}
					layer.close(layer.index);
				});
			},
			// 点击上传封面
			coverFun: function() {
				this.$refs.cover_file.click();
			},
			// 上传封面
			uploadCover: function(e) {
				let _this = this;
				let layIndex = layer.load(2, {
					shade: [0.1, '#ececec']
				});
				let file = e.target.files[0];
				// 清除file
				let obj = document.getElementById('coverFile');
				obj.value = '';
				obj.outerHTML = obj.outerHTML;
				// 压缩图片
				var reader = new FileReader(),
					img = new Image();
				var canvas = document.createElement('canvas');
				var context = canvas.getContext('2d');
				if(typeof(file) == 'undefined') {
					layer.msg('图片上传失败');
					layer.close(layIndex);
					return false;
				}
				reader.readAsDataURL(file);
				reader.onload = function(e) {
					img.src = e.target.result;
				};
				img.onload = function () {
					// 图片原始尺寸
					var originWidth = this.width;
					var originHeight = this.height;
					// 最大尺寸限制
					var maxWidth = 850, maxHeight = 1650;
					// 目标尺寸
					var targetWidth = originWidth, targetHeight = originHeight;
					// 图片尺寸超过限制
					if(originWidth > maxWidth || originHeight > maxHeight) {
						if(originWidth / originHeight > maxWidth / maxHeight) {
							// 更宽，按照宽度限定尺寸
							targetWidth = maxWidth;
							targetHeight = Math.round(maxWidth * (originHeight / originWidth));
						} else {
							targetHeight = maxHeight;
							targetWidth = Math.round(maxHeight * (originWidth / originHeight));
						}
					}
					// canvas对图片进行缩放
					canvas.width = targetWidth;
					canvas.height = targetHeight;
					// 清除画布
					context.clearRect(0, 0, targetWidth, targetHeight);
					// 图片压缩
					context.drawImage(img, 0, 0, targetWidth, targetHeight);
					// canvas转为blob并上传
					var dataurl = canvas.toDataURL('image/png');
					var blob = dataURLtoBlob(dataurl);
					// 创建forme
					var form = new FormData();
					form.append('img', blob, "image.png");
					form.append("upload_path", "ktv_test");
					// 上传
					$.ajax({
						type: "post",
						dataType: "json",
						processData: false,
						contentType: false,
						url: Vue.ctUrl + "Upload/api_uploadPic",
						crossDomain: true,
						xhrFields: {
							withCredentials: true
						},
						data: form,
						success: function(data) {
							if(data.response.result_code == "true") {
								_this.edit_cover = data.response.resault.img_url;
								$('.edit-img-cover').attr('suc', '1');
							} else {
								Vue.timeoutfun(data.response.result_status, _this);
								layer.msg("图片上传失败");
							}
							layer.close(layIndex);
						},
						error: function(err) {
							layer.msg("网络原因");
							layer.close(layIndex);
						}
					});
				}
			},
			// 返回列表
			backList: function() {
				this.showList = true;
			},
			// 新增、修改
			editSrs: function() {
				let _this = this;

				if(_this.edit_listorder == '') {
					layer.msg('请输入推荐序号');
					return false;
				} else if(_this.edit_name == '') {
					layer.msg('请输入标题');
					return false;
				} else if(_this.edit_goods_txt == '') {
					layer.msg('请选择推荐商品或者商品套餐');
					return false;
				} else if($('.edit-img-cover').attr('suc') != '1') {
					layer.msg('请上传推荐主图');
					return false;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"shop_id": $(_this.$refs.edit_shop).val(),
							"listorder": _this.edit_listorder,
							"title": _this.edit_name,
							"outside_goods_type": $(_this.$refs.edit_goods_type).val(),
							"goods_type": _this.goods_type_id,
							"merchant_goods_id": _this.goods_id,
							"picture": _this.edit_cover
						}
					},
					"comment": ""
				};
				let url = Vue.ctUrl + "Hall/addBanner";
				if(_this.modify == '2') {
					url = Vue.ctUrl + "Hall/updateBanner";
					datas["request"]["param"]["id"] = _this.edit_id;
				}
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: url,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg('操作成功');
							$(_this.$refs.srs_list).bootstrapTable("refresh");
							_this.showList = true;
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},

		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.srs-manage-wrap {
		.srs-edit {
			.srs-dash {
				padding: 0;
				margin: 0 15px 30px;
				>div {
					width: 524px;
					padding: 20px 15px;
					border: 1px dashed #CCC;
				}
				p {
					margin: 0 0 30px;
				}
				img {
					float: left;
					width: 114px;
					height: 114px;
					margin: 0 39px 0 0;
					cursor: pointer;
				}
			}
			.edit-img {
				input {
					display: none;
				}
			}
		}
		.edit-goods-alert {
			display: none;
			padding: 20px 30px 50px;
			.btns {
				width: 260px;
				margin: 10px auto 0;
				button {
					margin: 0 30px 0 0;
				}
			}
		}
	}
</style>